/**
 * Ask Client SDK - Browser-compatible JavaScript/TypeScript client
 * 
 * A lightweight SDK for integrating Ask's multi-LLM API into web applications.
 * Supports 11 AI providers with 560+ models, streaming responses, and unified API.
 * 
 * @packageDocumentation
 */

export { AskClient } from './AskClient';
export type {
	IAskClientOptions,
	IAskConfig,
	ICompletionRequest,
	ICompletionResponse,
	IErrorResponse,
	IMessage,
	IStreamChunk,
} from './types';





